function a(a,o,i,t){a._m(o),a.o(o,"AuthLayout",()=>a.f(u)),a.o(o,"MainLayout",()=>a.f(c));var u=a.i(i("c25ec185")),c=a.i(i("78a4e6b4"));}